import isHotkey from 'is-hotkey';
import { getTabs, setTabs } from './BlockProps';
import { toggleMark } from './MarkProps';
var hotKeysMarks = {
    'ctrl+b': 'bold',
    'ctrl+i': 'italic',
    'ctrl+u': 'underline'
};
var hotKeyElement = {
    tab: 'indent',
    'shift+tab': 'outdent'
};
export var hotKeysValue = function (editor, event) {
    for (var hotkey in hotKeysMarks) {
        if (isHotkey(hotkey, event)) {
            event.preventDefault();
            var mark = hotKeysMarks[hotkey];
            toggleMark(editor, mark);
        }
    }
    for (var hotkey in hotKeyElement) {
        if (isHotkey(hotkey, event)) {
            event.preventDefault();
            var props = hotKeyElement[hotkey];
            if (props === 'indent' || props === 'outdent') {
                var tab = getTabs(editor);
                if (props === 'indent') {
                    setTabs(editor, tab + 1);
                }
                else {
                    setTabs(editor, tab - 1);
                }
            }
        }
    }
};
//# sourceMappingURL=HotKeys.js.map